<template>
  <div v-if="!isPrint">
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="onSelectField" />

    <!-- 사업장 개요 -->
    <div class="mt-7">
      <h5><i class="dot"></i> {{ outlineTitle }}</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>{{ outlineLabel }}</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.field_name }}</p>
          <ml-input :readonly="true" v-model="form.fieldInfo.field_name" v-else />
        </div>
        <div>
          <div>현장주소</div>
          <p v-if="isPrint" class="print-input">fd</p>
          <ml-input :readonly="true" v-model="form.fieldInfo.address" v-else />
        </div>
      </div>
    </div>

    <div v-for="(listItem, listIndex) in form.listLabels" :key="listIndex" class="mt-7">
      <div class="flex items-center">
        <div v-if="editListLabelIndexes.includes(listIndex)" style="display: flex; align-items: center"><i class="dot"></i><ml-input v-model="form.listLabels[listIndex]" /></div>
        <h5 v-else><i class="dot"></i>{{ listItem }}</h5>
        <feather-icon icon="EditIcon" style="width: 22px; height: 22px; color: #7367f0; cursor: pointer" class="ml-2" @click.prevent.stop="onClickEditListLabel(listIndex)" />
      </div>
      <table-custom
        :board="board"
        :is-print="isPrint"
        :controls="false"
        :multiple="false"
        :tableData="[
          { id: 'input1', title: '구분', type: 'text', placeholder: '내용' },
          { id: 'input2', title: '연락처', type: 'text', placeholder: '내용' },
          { id: 'input3', title: '임무 및 역할', type: 'textarea', placeholder: '내용' },
        ]"
        v-model="form[`list_${listIndex + 1}`]"
      />
    </div>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
  <print v-else :listLabels="form.listLabels" :form="form" />
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import Print from "./Print.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    FieldSelectModule,
    TableCustom,
    FileUploadModule,
    Print,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    postId() {
      return this.$route.params.postId;
    },
    outlineTitle() {
      return "사업장 개요";
    },
    outlineLabel() {
      return "사업장(현장)명";
    },
  },
  data() {
    return {
      editListLabelIndexes: [], // 현재 편집되고 있는 listLabel의 인덱스 번호
      form: {
        stdInfo: {},
        fieldInfo: {
          field_name: "",
          address: "",
        },
        fileList: [],

        list_1: [
          { input1: "", input2: "", input3: "" },
          { input1: "", input2: "", input3: "" },
        ],
        list_2: [{ input1: "", input2: "", input3: "" }],
        list_3: [{ input1: "", input2: "", input3: "" }],
        list_4: [{ input1: "", input2: "", input3: "" }],
        list_5: [
          { input1: "주간", input2: "", input3: "" },
          { input1: "야간", input2: "", input3: "" },
        ],
        list_6: [{ input1: "", input2: "", input3: "" }],
        list_7: [{ input1: "", input2: "", input3: "" }],
        list_8: [{ input1: "", input2: "", input3: "" }],
        list_9: [{ input1: "", input2: "", input3: "" }],
        list_10: [{ input1: "", input2: "", input3: "" }],
        list_11: [{ input1: "", input2: "", input3: "" }],

        listLabels: [
          "경상남도 안전총괄관",
          "경상남도청",
          "경상남도청 종합상황실",
          "창원지청",
          "경상남도소방본부",
          "한국산업안전보건공단",
          "전기안전공사(경남지역본부)",
          "한국전력공사(경남본부직할)",
          "한국가스공사(경남지역본부)",
          "한국승강기안전공단(경남지역본부)",
          "국토교통부 건설정책국",
        ],
      },
    };
  },
  created() {
    // 마지막 문서의 listLabels 를 호출하여 가져온다.
    // 단, 수정시엔 문서의 listLabels 를 사용한다.
    if (this.postId) return;
    const projectId = this.projectId;
    const boardId = this.boardId;
    const page = 1;
    const perPage = 1;

    const params = {
      projectId,
      boardId,
      page,
      perPage,
      orderTarget: "created_at",
      orderDirection: "desc",
    };

    new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/board/post/${boardId}`, { params }).then((response) => {
        const data = response.data;
        if (data.length < 1) return;
        const content = JSON.parse(data[0].post_content).body;
        this.$set(this.form, "listLabels", content.listLabels);
      });
    });
  },
  methods: {
    onSelectField(data) {
      this.form.fieldInfo.field_name = data.field_name;
      this.form.fieldInfo.address = data.address;
    },
    onClickEditListLabel(index) {
      // editListLabelIndexs 항목에 없으면 추가하고, 있으면 제거한다
      if (this.editListLabelIndexes.includes(index)) {
        this.editListLabelIndexes.splice(this.editListLabelIndexes.indexOf(index), 1);
      } else {
        this.editListLabelIndexes.push(index);
      }
    },
  },
};
</script>
